export enum ActionType {
  SET_CERTIFICATE = 'SET_CERTIFICATE',

  GET_CERTIFICATE_SCAN_HISTORY = 'GET_CERTIFICATE_SCAN_HISTORY',
  SET_CERTIFICATE_SCAN_HISTORY = 'SET_CERTIFICATE_SCAN_HISTORY',

  GET_TABSSUMMARY = 'GET_TABSSUMMARY',
  SET_TABSSUMMARY = 'SET_TABSSUMMARY',

  TRANSFER_CERTIFICATE = 'TRANSFER_CERTIFICATE',
  EDIT_TRANSFER_METADATA = 'EDIT_TRANSFER_METADATA',
  CONFIRM_TRANSFER_CERTIFICATE = 'CONFIRM_TRANSFER_CERTIFICATE',
  CANCEL_TRANSFER_CERTIFICATE = 'CANCEL_TRANSFER_CERTIFICATE',
  REQUEST_CANCEL_TRANSFER_CERTIFICATE = 'REQUEST_CANCEL_TRANSFER_CERTIFICATE',
  CONFIRM_CANCEL_REQUEST_TRANSFER_CERTIFICATE = 'CONFIRM_CANCEL_REQUEST_TRANSFER_CERTIFICATE',
  REJECT_CANCEL_REQUEST_TRANSFER_CERTIFICATE = 'REJECT_CANCEL_REQUEST_TRANSFER_CERTIFICATE',

  PREVIEW_PUBLIC_CERTIFICATE = 'PREVIEW_PUBLIC_CERTIFICATE',
  EDIT_CERTIFICATE_SETTINGS = 'EDIT_CERTIFICATE_SETTINGS',

  SCAN_GEOLOCATION = 'SCAN_GEOLOCATION',

  CHANGE_CERTIFICATE_STATUS_BY_CUSTOMER = 'CHANGE_CERTIFICATE_STATUS_BY_CUSTOMER',
}

import type { ProductCategory } from '@repo/types'

import type {
  Pagination,
  CertificateCustomer,
  CerteficateTab,
  CertificateStatus,
  EmptyObject,
  ScanHistory,
  Sort,
} from 'types'

export type PaginationParams = {
  limit?: number
  offset?: number
}

export type CertificatesFilter = {
  tab: CerteficateTab
  status: CertificateStatus
  type: ProductCategory
}

export type CertificatesParams = PaginationParams & {
  tab?: CerteficateTab
  status?: string | null
  type?: string | null
  sort?: string | null
  sort_by?: string | null
  query?: string | null
  certificateIds?: string | null
}

export type Certificates = {
  data: CertificateCustomer[]
  filter: CertificatesFilter | EmptyObject
} & Pagination

export type CertificateScanHistoryParams = {
  id: string
  sort?: Sort
} & PaginationParams

export type CertificateScanHistoryData = {
  data: ScanHistory[]
} & Pagination

export interface ITabsSummary {
  name: string
  count: number
}

export interface ITransferCertificateData {
  certificateId: string
  customerEmail: string | undefined
  price: number
}

export type ScanGeolocationPayload = {
  certificateId: string
  hash: string
  location: {
    latitude: number
    longitude: number
  }
}
